import React from 'react';
import PropTypes from 'prop-types';
import { addButtonIcon } from 'assets';
import headerStyles from '../header/styles.module.css';
import styles from './styles.module.css';

export const AddButton = ({ alt, title, disabled, onClick, style, hidden }) => {
  return (
    <img
      src={addButtonIcon}
      className={`${headerStyles.helpIcon} ${styles.addIcon}`}
      style={style}
      alt={alt}
      title={title}
      onClick={onClick}
      disabled={disabled}
      hidden={hidden}
    />
  );
};

AddButton.propTypes = {
  alt: PropTypes.string,
  title: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  style: PropTypes.shape(),
  title: PropTypes.string,
  hidden: PropTypes.bool,
};

AddButton.defaultProps = {
  alt: 'Add button',
  title: 'New',
  disabled: false,
  onClick: null,
  style: null,
  hidden: false,
};
